import requestInstance from '../../../utils/instance-utils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getUserFavoriteContent = () =>
    requestInstance.get('/user/get-all-favorites');

export const deleteFavoriteContent = (id: number) =>
    requestInstance.delete(`/user/delete-favorites?id=${id}`);
